import React, { useState, useEffect, useRef } from "react";
import { ReactDOM } from "react";
import "./NewPlancomponent.css";

import watch from "../../Assets/newAsset/lpassets/Watch.webp";

import folder from "../../Assets/newAsset/lpassets/folder.webp";
import folder2 from "../../Assets/newAsset/lpassets/folder2.svg";
import watch2 from "../../Assets/newAsset/lpassets/watch2.svg";
import testTube from "../../Assets/newAsset/lpassets/testTubes.webp";
import homeCar from "../../Assets/newAsset/lpassets/homeCar.svg";
import homeCar2 from "../../Assets/newAsset/lpassets/homeCar2.svg";
import PlanDetailAccordion from "./PlanDetailAccordion";
import Breadcrumb from "./Breadcrumbs";

import Tool1 from "../../Assets/newAsset/plandetails/docTool1.svg";
import Tool2 from "../../Assets/newAsset/plandetails/tool2.svg";

import Tool3 from "../../Assets/newAsset/plandetails/tool3.svg";
import { Link } from "react-scroll";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import BookForm from "./BookForm";
import { AiFillInfoCircle } from "react-icons/ai";
import { AddtoCart, getCartDetails, setCity } from "../../Redux/Actions";
import TestParameter from "./TestParameter";
import { Helmet } from "react-helmet";
import { Modal } from "react-responsive-modal";
import Popup from "../PopupNotification/Popup";
import "react-responsive-modal/styles.css";

//plandetail
const dataforPlan = [
  {
    id: 1,
    img: Tool1,
    question: "Who all are eligible for the test?",
    answer: "",
  },
  {
    id: 2,
    img: Tool2,
    question: "Why take this test?",
    answer: "",
  },
  {
    id: 3,
    img: Tool3,
    question: "What are the benefits of this test?",
    answer: "",
  },
];

//test parameter accordion
const dataforTest = [
  {
    id: 1,
    img: "",
    question: "Complete Hemogram (24 Tests)",
    answer: "",
  },
  {
    id: 2,
    img: "",
    question: "Liver Function Tests (12 Tests)",
    answer: "",
  },
  {
    id: 3,
    img: "",
    question: "Urine Routine & Microscopy (21 Tests)",
    answer: "",
  },
];

//QNA
const QNAaRRAY = [
  {
    question: "Who all are eligible for this test?",
    answer:
      "Kidney function test is a simple process that uses the blood or urine samples to help analyze the problems in kidneys.",
  },
  {
    question: "Who all are eligible for this test?",
    answer:
      "Kidney function test is a simple process that uses the blood or urine samples to help analyze the problems in kidneys.",
  },
  {
    question: "Who all are eligible for this test?",
    answer:
      "Kidney function test is a simple process that uses the blood or urine samples to help analyze the problems in kidneys.",
  },
];
///EXPORT COMPONENT STARTS
export const Warning = ({ desc }) => {
  return (
    <div className="parentWarDiv">
      <div className="warning">
        <AiFillInfoCircle />
        <span>{desc}</span>
      </div>
    </div>
  );
};

export const Regards = () => {
  return (
    <div className="parentWarDiv">
      <div className="noWar noWar2">
        <img
          src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/1d439d3b-60b8-4660-a56c-2fbde90e20fa.svg"
          alt="https://staticcdn.redcliffelabs.com/media/gallary-file/None/1d439d3b-60b8-4660-a56c-2fbde90e20fa.sv"
        />
        <span>FREE E-Report will be sent to your registered email ID</span>
      </div>
    </div>
  );
};

//EXPORT COMPONENT ENDS
function NewPlanComponent({
  packageDetails,
  QNA,
  btmQna,
  testPara,
  citySel,
  btn,
}) {
  console.log(citySel.replace("_", " "), "NewPlanComponent");
  //city List
  const navCity = useSelector((state) => state.navCityList);
  const { navCities, navloading } = navCity;

  ///
  const [searchCity, setSearchCity] = useState("");
  const [display, setDisplay] = useState(true);
  const [open, setOpen] = useState(false);
  const onOpenModal = () => setOpen(true);
  const onCloseModal = () => setOpen(false);

  //
  const handelCity = (city) => {
    const userProfile = JSON.parse(localStorage.getItem("user"));
    localStorage.setItem("city", city);
    setSearchCity(city);
    dispatch(setCity(city != "" ? city : ""));
    setDisplay(false);
    // e.target.blur();
    // userProfile && userProfile !== ""
    //   ? dispatch(EmptyCart(userProfile && userProfile.token, successCd))
    //   : null;
  };
  const [intro, setIntro] = useState(true);
  const [param, setparam] = useState(false);
  const [crieteria, setCrieteria] = useState(false);
  const [cityBlank, setcityBlank] = useState(false);
  const [QNAactive, seQna] = useState(false);
  const [openCartt, setOpenCartt] = useState(false);
  // const [StickyHead, setStickyHead] = useState(false);
  const onCloseModalCartt = () => setOpenCartt(false);

  const history = useHistory();
  const dispatch = useDispatch();
  //GETTING RESPONSE FROM STORE
  const cartStatus = useSelector((state) => state.addToCartReducer);

  const citySelected = useSelector((state) => state.cityOnTopNav);
  const { loading: loadingCity, citySelect } = citySelected;

  const setIntroActive = () => {
    setIntro(true);
    setparam(false);
    setCrieteria(false);
    seQna(false);
  };

  const paramsActive = () => {
    setIntro(false);
    setparam(true);
    setCrieteria(false);
    seQna(false);
  };

  const setCrieteriaActive = () => {
    setIntro(false);
    setparam(false);
    setCrieteria(true);
    seQna(false);
  };

  const setQna = () => {
    setIntro(false);
    setparam(false);
    setCrieteria(false);
    seQna(true);
  };

  const Mrp = packageDetails?.package_city_prices?.package_price
    ? packageDetails?.package_city_prices?.package_price
    : packageDetails?.package_price;
  const offerPrice = packageDetails?.package_city_prices?.offer_price
    ? packageDetails?.package_city_prices?.offer_price
    : packageDetails?.offer_price;
  const discount = Mrp - offerPrice;
  const finalPrice = Mrp - discount;

  var discountPrice = 0;

  const discountPercentage = Math.ceil((discount / Mrp) * 100);

  const successCb = () => {
    const userFromLocal = JSON.parse(localStorage.getItem("user"));
    var token = userFromLocal.token;
    dispatch(getCartDetails(token, citySel));
  };

  const addtocart = (packageid) => {
    const userFromLocal = JSON.parse(localStorage.getItem("user"));
    var token = userFromLocal && userFromLocal.token;

    const body = {
      package: packageid,
    };

    if (token && token !== "" && token && citySelect != "") {
      dispatch(AddtoCart(body, token, successCb));
    } else if (citySelect == "" || citySelect == null) {
      setOpenCartt(true);
    } else {
      dispatch(AddtoCart(body, token, successCb));
      history.push({
        pathname: "/login",
        packageId: packageid,
      });
    }
  };

  useEffect(() => {
    dispatch({
      type: "EPMTY_CART_OBJECT",
    });
  }, []);
  const [cartButton, setButton] = useState("Add to cart");

  useEffect(() => {
    if (cartStatus && cartStatus.cart && cartStatus.cart !== "") {
      if (cartStatus?.loading == true) {
        console.log("CART ADD STATUS", cartStatus.loading);
        setButton("Adding");
      } else {
        setButton("Added");
      }
    } else {
      setButton("Add to Cart");
    }
  }, [cartStatus, cartStatus && cartStatus.loading]);

  useEffect(() => {
    let scroll = window.addEventListener("scroll", (e) => onScrolled(e));
    return () => {
      window.removeEventListener("scroll", (e) => onScrolled(e));
    };
  }, []);

  useEffect(() => {
    setTimeout(() => {
      onOpenModal();
    }, 30000);
  }, []);

  const handleCitySubmit = (e) => {
    localStorage.setItem("city", e.target.value);
    dispatch(setCity(e.target.value));
    e.target.blur();
  };

  const onScrolled = (e) => {
    // console.log(e,'99999999999999999999999999999999999999999')
    let scrollY = window.scrollY;
  

    let cri_height = 0;
    let params_height = 0;
    let qanss_height = 0;
    let intro_height = 0;
    let newWarning = 0;
    let doc = document.getElementById("criteria");
    let doc2 = document.getElementById("parameter");
    let doc3 = document.getElementById("QNA");
    let doc4 = document.getElementById("NewIntro");
    let doc5 = document.getElementById("newWarning");
    let doc6 = document.getElementById("packageHeading");
    let doc7 = document.getElementById("selectNavId");

    // if (Math.ceil(scrollY) < 196) {
    //   console.log("196 se km >>>>");
    //   setStickyHead(true);
    // } else if (Math.ceil(scrollY) > 196) {
    //   console.log("196 se jayada >>>>");
    //   setStickyHead(false);
    // }

    if (doc5) {
      newWarning = doc5.clientHeight;
      console.log(newWarning, "lower childerrrrrn lll");
    }
    if (doc4) {
      intro_height = doc4.clientHeight + doc6.clientHeight + doc7.clientHeight;
      console.log(intro_height, "intro height lll");
    }
    if (doc) {
      // criet = doc.getBoundingClientRect().top;
      cri_height = doc.clientHeight;
      console.log(cri_height, "criett height lll");
    }
    if (doc2) {
      // params = doc2.getBoundingClientRect().top;
      params_height = doc2.clientHeight;
      console.log(params_height, "params height lll");
    }
    if (doc3) {
      // qanss = doc3.getBoundingClientRect().top;
      qanss_height = doc3.clientHeight;
      console.log(qanss_height, "qna div height lll");
    }
    if (scrollY == 0) {
      setIntro(true);
      setparam(false);
      setCrieteria(false);
      seQna(false);
    }

    if (scrollY > 0) {
      let newIntroHeight = newWarning + newWarning + intro_height;
      // console.log(newWarning,'intro_height')
      // // console.log(qanss, '1111111111111')
      // const sectionTop = criet;
      // console.log(sectionTop,'criteria toppp')
      // const paramTop = params;
      // console.log(paramTop,'paramTopppp')
      // const qnaTop = qanss;
      // console.log(qnaTop,'qnaTopppp')
      // setIntro(true);
      if (
        Math.ceil(scrollY) > newIntroHeight &&
        Math.ceil(scrollY) < newIntroHeight + cri_height + 120
      ) {
        setIntro(false);
        setparam(false);
        setCrieteria(true);
        seQna(false);
      } else if (
        Math.ceil(scrollY) > cri_height + newIntroHeight + 120 &&
        Math.ceil(scrollY) < cri_height + newIntroHeight + params_height + 120
      ) {
        setIntro(false);
        setparam(true);
        setCrieteria(false);
        seQna(false);
      } else if (
        Math.ceil(scrollY) >
          cri_height + newIntroHeight + params_height + 120 &&
        Math.ceil(scrollY) <
          cri_height + newIntroHeight + params_height + qanss_height + 120
      ) {
        setIntro(false);
        setparam(false);
        setCrieteria(false);
        seQna(true);
      } else if (scrollY < newIntroHeight + cri_height) {
        setIntro(true);
        setparam(false);
        setCrieteria(false);
        seQna(false);
      }
    }
  };

  const Description = ({ param }) => {
    return (
      <span clas>
        {param?.name}({param?.package_details?.length} tests),{" "}
      </span>
    );
  };

  const parentRef = useRef();

  const [offset, setOffset] = useState(-180);
  useEffect(() => {
    window && window.screen && window.screen.width;
    if (window && window.screen && window.screen.width < 780) {
      setOffset(-140);
    } else {
      setOffset(-180);
    }
  });

  // const [crumbs, setCrumbs] = useState([
  //   "Home",
  //   "Category",
  //   `${packageDetails.name}`,
  // ]);

  // const selected = (crumb) => {
  //   console.log(crumb);
  // };

  const cartHandler = (e) => {
    addtocart(packageDetails.id);
  };

  return (
    <>
      <Helmet>
        <title data-react-helmet="true" property="og:title">
          {packageDetails.package_city_metainfo
            ? packageDetails.package_city_metainfo.meta_title
            : packageDetails.meta_title?.replace(
                "in Delhi",
                `${citySel ? `in ${citySel}` : ""}`
              )}
        </title>
        <meta
          name="description"
          data-react-helmet="true"
          property="og:description"
          content={
            packageDetails.package_city_metainfo
              ? packageDetails.package_city_metainfo.meta_description
              : packageDetails.meta_description?.replace(
                  "in Delhi",
                  `${citySel ? `in ${citySel}` : ""}`
                )
          }
        ></meta>
        <meta
          name="description"
          data-react-helmet="true"
          property="og:description"
          content={
            packageDetails.package_city_metainfo
              ? packageDetails.package_city_metainfo.meta_keyword
              : packageDetails.meta_keyword
          }
        ></meta>
      </Helmet>

      <div className="main_plancomponent" ref={parentRef}>
        <div className="plancomponentContent">
          {/* <Breadcrumb crumbs={crumbs} selected={selected} /> */}
          <div className="upperSection">
            <div className="leftside_section">
              <div id="packageHeading" className="reverseView">
                <h1 className="headingPink headingBlack">
                  {packageDetails.name}{" "}
                  {citySel ? `in ${citySel.replace("_", " ")}` : null}
                </h1>

                {packageDetails.parameter > 1 ? (
                  <p>
                    Includes:
                    <span className="cardInfo_mainHeading">
                      {" "}
                      {packageDetails?.parameter} tests
                    </span>
                  </p>
                ) : (
                  <p>
                    Includes:
                    <span className="cardInfo_mainHeading">
                      {" "}
                      {packageDetails?.parameter} test
                    </span>
                  </p>
                )}

                <p>{packageDetails?.description}</p>
              </div>
              <ul id="selectNavId" className="selectNav">
                <div className="nav-list">
                  <li className="navListItem firstLiItem">
                    <Link
                      onClick={setIntroActive}
                      className={
                        intro && intro
                          ? "navListItem currentSelected"
                          : "navListItem"
                      }
                      to="packageHeading"
                      offset={offset}
                      smooth={true}
                      duration={0}
                    >
                      Introduction
                    </Link>
                  </li>
                  {QNA && QNA?.length && QNA?.length !== 0 ? (
                    <li className="navListItem">
                      <Link
                        onClick={setCrieteriaActive}
                        className={
                          crieteria
                            ? "navListItem currentSelected"
                            : "navListItem "
                        }
                        to="criteria"
                        offset={offset}
                        smooth={true}
                        duration={0}
                      >
                        Test Criteria
                      </Link>
                    </li>
                  ) : null}
                  <li className="navListItem">
                    {testPara && testPara?.length && testPara?.length !== 0 ? (
                      <Link
                        onClick={paramsActive}
                        className={
                          param ? "navListItem currentSelected" : "navListItem"
                        }
                        to="parameter"
                        offset={offset}
                        smooth={true}
                        duration={0}
                      >
                        Test Parameters
                      </Link>
                    ) : null}
                  </li>
                  {QNA && QNA?.length && QNA?.length !== 0 ? (
                    <li className="navListItem">
                      <Link
                        onClick={setQna}
                        className={
                          QNAactive
                            ? "navListItem currentSelected "
                            : "navListItem"
                        }
                        to="QNA"
                        offset={offset}
                        smooth={true}
                        duration={0}
                      >
                        Q&A
                      </Link>
                    </li>
                  ) : null}
                </div>
              </ul>
              <div className="introduction">
                <div className="lowerChild" id="NewIntro">
                  {/*CARDS INFO HERE */}
                  <div className="Newinfo_card newinfo_card2">
                    {packageDetails.home_collection ? (
                      <div className="infocards_container">
                        <div className="infocards infocards2">
                          <div className="card_infoIMG">
                            <img src={homeCar2} alt={homeCar} width="100" />
                          </div>
                          <div className="Newinfo_cardContent">
                            <span className="cardInfo_mainHeading cardInfo_mainHeading2">
                              Home Collection
                            </span>
                            <span className="cardInfo_redHeading cardInfo_redHeading2">
                              Available
                            </span>
                          </div>
                        </div>
                      </div>
                    ) : null}

                    {packageDetails.tat_time &&
                    packageDetails.tat_time !== "" ? (
                      <div className="infocards infocards2">
                        <div className="card_infoIMG">
                          <img src={folder2} alt={folder} width="100" />
                        </div>
                        <div className="Newinfo_cardContent">
                          <span className="cardInfo_mainHeading cardInfo_mainHeading2">
                            Get Reports in
                          </span>
                          <span className="cardInfo_redHeading cardInfo_redHeading2">
                            {packageDetails.tat_time}
                          </span>
                        </div>
                      </div>
                    ) : null}

                    {/* {packageDetails.fasting_time &&
                      packageDetails.fasting_time !== "" ? (
                      <div className="infocards infocards2">
                        <div className="card_infoIMG">
                          <img src={fasting} alt={fasting} width="100" />
                        </div>
                        <div className="Newinfo_cardContent">
                          <span className="cardInfo_mainHeading cardInfo_mainHeading2">
                            Fasting Requirement
                          </span>
                          <span className="cardInfo_redHeading cardInfo_redHeading2">
                            {packageDetails.fasting_time}
                          </span>
                        </div>
                      </div>
                    ) : null} */}

                    {packageDetails.recommended_age &&
                    packageDetails.recommended_age !== "" ? (
                      <div className="infocards infocards2">
                        <div className="card_infoIMG">
                          <img src={watch2} alt={watch} width="100" />
                        </div>
                        <div className="Newinfo_cardContent">
                          <span className="cardInfo_mainHeading cardInfo_mainHeading2">
                            Age Group
                          </span>
                          <span className="cardInfo_redHeading cardInfo_redHeading2">
                            {packageDetails.recommended_age} years
                          </span>
                        </div>
                      </div>
                    ) : null}

                    {packageDetails.specimen_instructions &&
                    packageDetails.specimen_instructions !== "" ? (
                      <div className="infocards infocards2">
                        <div className="card_infoIMG">
                          <img src={testTube} alt={testTube} width="100" />
                        </div>
                        <div className="Newinfo_cardContent">
                          <span className="cardInfo_mainHeading">
                            Sample Information
                          </span>
                          <span className="cardInfo_redHeading cardInfo_redHeading2">
                            {packageDetails.specimen_instructions}
                          </span>
                        </div>
                      </div>
                    ) : null}
                  </div>
                </div>

                {/** WARNING AND NO WARNING DIV */}
                {packageDetails.fasting_time &&
                packageDetails.fasting_time !== "" ? (
                  <div className="parentWarDiv" id="newWarning">
                    <div className="warning warning2">
                      <AiFillInfoCircle />

                      <span>{packageDetails.fasting_time}</span>
                    </div>
                  </div>
                ) : null}
                <Regards />
              </div>

              {/**ACCORDION TEST */}
              <div className="scrollSticky">
                {QNA && QNA?.length && QNA?.length !== 0 ? (
                  <div
                    className="accordionDiv_pacakgeDetail accordionDiv_pacakgeDetail2"
                    id="criteria"
                  >
                    <h2 className="subHeading_planDetail subHeading_planDetail2">
                      Test Criteria
                    </h2>
                    {QNA &&
                      QNA.map((allData, index) => {
                        return (
                          <PlanDetailAccordion key={index} data={allData} />
                        );
                      })}
                  </div>
                ) : null}

                {/** TEST PARAMETERS ACCORDION  */}
                {testPara?.length >= 1 && (
                  <div
                    className="accordionDiv_pacakgeDetail accordionDiv_pacakgeDetail2"
                    id="parameter"
                  >
                    <h2 className="subHeading_planDetail subHeading_planDetail2">
                      Test Parameters
                    </h2>

                    {testPara &&
                      testPara.map((allData, index) => {
                        return <TestParameter key={index} data={allData} />;
                      })}
                  </div>
                )}

                {btmQna && (
                  <div className="lowerSection" id="QNA">
                    <div className="testQuestionAnswers">
                      <h2 className="subHeading_planDetail subHeading_planDetail2">
                        Questions & Answers
                      </h2>
                      <div className="testQuestionAnswers_row">
                        {btmQna &&
                          btmQna.map((values, index) => {
                            return (
                              <div className="question_content" key={index}>
                                <span className="cardInfo_mainHeading">
                                  {values.question}
                                </span>

                                <p>{values.answer}</p>
                              </div>
                            );
                          })}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className="rightside_section">
              <BookForm
                empty={true}
                packageDetails={packageDetails}
                details=""
                packDetail={true}
                btn={btn}
              />
            </div>
          </div>
        </div>
        <div className="floatingBooking">
          <div className="border-book">
            <div
              className="price"
              style={{
                flexDirection: "column-reverse",
                alignItems: "flex-start",
              }}
            >
              <span
                style={{
                  textDecoration: "line-through",
                  color: "gray",
                  fontSize: "1.3rem",
                }}
              >
                Rs. {Mrp}/-
              </span>{" "}
              <span className="PriceColor">Rs. {offerPrice}/-</span>
            </div>
            <div className="discount">
              <span>Get {discountPercentage}% OFF</span>
            </div>
            <div className="New_bookNow">
              <span onClick={() => addtocart(packageDetails.id)}>
                {cartButton}
              </span>
            </div>
          </div>
        </div>
      </div>
      <Modal
        open={openCartt}
        onClose={onCloseModalCartt}
        center
        classNames={{
          modal: "selectedCityForPackage",
        }}
      >
        {/*<hr className="topHr" />*/}
        <div className="packageDrop">
          <hr className="topHr" />
          <div className="citySelectHome">
            <form>
              <input
                onClick={() => {
                  setDisplay(true);
                }}
                onFocus={(e) => {
                  e.target.select(), setDisplay(true);
                }}
                style={{ width: "90px" }}
                className="cityDrop_model"
                value={searchCity.replace("_", " ")}
                onChange={(e) => {
                  setSearchCity(e.target.value.replace(" ", "_")),
                    setDisplay(true);
                }}
                placeholder="search city"
              />
            </form>
            {display ? (
              <div className="divCity" defaultValue="Noida">
                <span
                  onFocusCapture={() => {
                    setDisplay(false), setSearchCity(""), handelCity("");
                  }}
                  value=""
                >
                  Select City
                </span>
                {navCity && navCity.navCities && navCity.navCities.cities
                  ? navCity.navCities.cities
                      .filter((city, index) => {
                        if (searchCity == "") {
                          return city;
                        } else if (
                          city.toLowerCase().includes(searchCity.toLowerCase())
                        ) {
                          return city;
                        }
                      })
                      .map((ele, index) => {
                        return (
                          <span
                            onClick={() => handelCity(ele)}
                            key={index}
                            selected={ele == citySelected.citySelect}
                            value={ele}
                          >
                            {ele.replace("_", " ")}
                          </span>
                        );
                      })
                  : " <Loader />"}
              </div>
            ) : null}
          </div>
          <hr className="bottomHr" />
          <div className="cartButtons">
            <button className="closeModal" onClick={() => closeCartModal()}>
              Close
            </button>
          </div>
        </div>
      </Modal>

      {/* Notification popup */}
      <Modal
        classNames={{
          overlay: "customOverlay",
          modal: "notificationPopup_modal",
        }}
        open={open}
        onClose={onCloseModal}
        center
      >
        <Popup setOpen={setOpen} />
      </Modal>
    </>
  );
}

export default NewPlanComponent;
